const SLIDER_SELECTOR = '[data-image-tag-slider]';
const MOBILE_MEDIA_QUERY = window.matchMedia('(max-width: 767.98px)');

function initAllSliders() {
  const sliders = document.querySelectorAll(`${SLIDER_SELECTOR}:not([data-initialized])`);
  if (!sliders.length) return;

  sliders.forEach(slider => {
    slider.setAttribute('data-initialized', 'true');
    initSlider(slider);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSliders);
} else {
  initAllSliders();
}

document.addEventListener('shopify:section:load', initAllSliders);
document.addEventListener('shopify:section:select', initAllSliders);

function initSlider(slider) {
  const parentContainer = slider.closest('.image-tag-slider__wrapper') || slider.parentElement;
  if (!parentContainer) return;

  let isDown = false;
  let startX = 0;
  let prevTranslate = 0;
  let currentTranslate = 0;
  let minTranslate = 0;
  let isDragging = false;

  const getAvailableWidth = () => {
    const styles = window.getComputedStyle(parentContainer);
    const paddingLeft = parseFloat(styles.paddingLeft) || 0;
    const paddingRight = parseFloat(styles.paddingRight) || 0;
    return parentContainer.clientWidth - paddingLeft - paddingRight;
  };

  const updateLimits = () => {
    if (MOBILE_MEDIA_QUERY.matches) {
      parentContainer.classList.remove('is-draggable');
      slider.style.transform = '';
      prevTranslate = 0;
      currentTranslate = 0;
      minTranslate = 0;
      // Garante posição inicial correta no mobile (scroll-snap pode deslocar o
      // container quando imagens lazy carregam ou quando há reflow do layout)
      if (slider.scrollLeft !== 0) {
        slider.scrollLeft = 0;
      }
      return;
    }

    const visibleWidth = getAvailableWidth();
    let totalWidth = slider.scrollWidth;
    const needsDrag = totalWidth > visibleWidth;

    if (needsDrag) {
      parentContainer.classList.add('is-draggable');
      slider.offsetHeight;
      totalWidth = slider.scrollWidth;
      minTranslate = Math.min(0, visibleWidth - totalWidth);
      currentTranslate = Math.max(minTranslate, Math.min(prevTranslate, 0));
      slider.style.transform = `translateX(${currentTranslate}px)`;
      prevTranslate = currentTranslate;
    } else {
      parentContainer.classList.remove('is-draggable');
      minTranslate = 0;
      currentTranslate = 0;
      slider.style.transform = `translateX(0px)`;
      prevTranslate = 0;
    }
  };

  const onPointerDown = event => {
    if (MOBILE_MEDIA_QUERY.matches) return;
    if (!parentContainer.classList.contains('is-draggable')) return;
    if (event.button && event.button !== 0) return;

    isDown = true;
    isDragging = false;
    startX = event.clientX;
    slider.classList.add('grabbing');

    const transformMatrix = new DOMMatrix(window.getComputedStyle(slider).transform);
    prevTranslate = transformMatrix.m41;

    // Não usa setPointerCapture aqui para permitir que cliques funcionem normalmente
    // Será usado apenas quando houver arrasto real no onPointerMove
  };

  const onPointerMove = event => {
    if (!isDown || MOBILE_MEDIA_QUERY.matches) return;

    const distance = event.clientX - startX;
    if (Math.abs(distance) > 5) {
      if (!isDragging) {
        // Primeira vez que detecta arrasto - captura o pointer e previne comportamento padrão
        isDragging = true;
        if (event.pointerId != null) {
          slider.setPointerCapture(event.pointerId);
        }
      }
      event.preventDefault();
    }

    // Só move o slider se houver movimento significativo
    if (isDragging) {
      currentTranslate = prevTranslate + distance;
      slider.style.transform = `translateX(${currentTranslate}px)`;
    }
  };

  const onPointerUp = event => {
    if (!isDown) return;
    isDown = false;
    slider.classList.remove('grabbing');

    if (currentTranslate > 0) {
      currentTranslate = 0;
    }
    if (currentTranslate < minTranslate) {
      currentTranslate = minTranslate;
    }

    slider.style.transform = `translateX(${currentTranslate}px)`;
    prevTranslate = currentTranslate;

    if (event && event.pointerId != null) {
      slider.releasePointerCapture(event.pointerId);
    }

    // Reseta isDragging após um pequeno delay para garantir que o evento click seja processado primeiro
    // O setTimeout com um pequeno delay garante que o evento click (que é síncrono) seja processado antes
    setTimeout(() => {
      isDragging = false;
    }, 10);
  };

  const onClick = event => {
    // Previne o clique no link se o usuário estava arrastando
    // Isso permite distinguir entre um clique simples e um arrasto
    // Verifica se o clique foi em um link dentro do slider
    const link = event.target.closest('a.image-tag-slider__item');
    if (link && isDragging) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    // Reseta isDragging após processar o clique para garantir que não interfira com cliques futuros
    isDragging = false;
  };

  window.addEventListener('resize', updateLimits);
  window.addEventListener('load', updateLimits, { once: true });
  if (MOBILE_MEDIA_QUERY.addEventListener) {
    MOBILE_MEDIA_QUERY.addEventListener('change', updateLimits);
  }
  updateLimits();

  // Resetar posição inicial quando cada imagem lazy termina de carregar.
  // iOS Safari com scroll-snap pode deslocar o container quando o layout muda.
  // Só reseta se o usuário ainda não interagiu (userHasScrolled == false).
  let userHasScrolled = false;
  slider.addEventListener('scroll', () => {
    // Um scroll > 2px conta como interação real do usuário
    if (slider.scrollLeft > 2) userHasScrolled = true;
  }, { passive: true });

  const resetIfUntouched = () => {
    if (!MOBILE_MEDIA_QUERY.matches) return;
    if (userHasScrolled) return;
    if (slider.scrollLeft !== 0) slider.scrollLeft = 0;
  };

  slider.querySelectorAll('img').forEach(img => {
    if (img.complete) return;
    img.addEventListener('load', resetIfUntouched, { once: true });
    img.addEventListener('error', resetIfUntouched, { once: true });
  });

  // Safeguard extra: também reseta após window.load + um pequeno delay
  // (pra pegar casos onde a transição de height do body causa reflow)
  window.addEventListener('load', () => {
    requestAnimationFrame(() => {
      setTimeout(resetIfUntouched, 500);
    });
  }, { once: true });

  slider.addEventListener('pointerdown', onPointerDown);
  slider.addEventListener('pointermove', onPointerMove);
  slider.addEventListener('pointerup', onPointerUp);
  slider.addEventListener('pointerleave', onPointerUp);
  slider.addEventListener('pointercancel', onPointerUp);
  slider.addEventListener('click', onClick);
}
